<template>
  <div class="history-query-title-search">
    <!-- 标题 -->
    <div class="history-query-title-search__title" :title="hoverTitle">
      {{title}}
      <span v-if="tips" class="tips-label">
        ({{ tips }})
      </span>
      <span v-if="showCount" class="num-text">
        {{displayCount}}
      </span>
    </div>
  </div>
</template>

<script>

export default {
    props: {
        title: {
            type: String,
            required: true
        },
        count: {
            type: Number,
            default: 0
        },
        showCount: {
            type: Boolean,
            default: false
        },
        tips: {
          type: String,
          default: '',
        }
    },
    computed: {
        displayCount() {
            return `(${this.numberFormat(this.count)})`;
        },
        hoverTitle() {
            return this.showCount ? `${this.title} ${this.displayCount}` : '';
        }
    },
    methods: {
        numberFormat(value) {
            const CurrencyFormatterRegx = new RegExp(/\d(?=(\d{3})+(?=\b))/g);
            return `${value}`.replace(CurrencyFormatterRegx, '$&,');
        }
    }
};
</script>

<style lang="scss">
.history-query-title-search{
  &::after{
    content:'';
    display: block;
    clear: both;
    width: 0;
    height: 0;
  }
  &__title {
    float: left;
    height: 28px;
    line-height: 28px;
    color: $text-primary;
    font-size: 20px;
    font-weight: bold;
    position: relative;
    max-width: 50vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .num-text{
        color: #bbc2cc;
        font-size: 16px;
        margin-left: 8px;
    }

    .tips-label {
      color: $text-disable;
      font-size: 14px;
      margin-left: 4px;
      font-weight: normal;
    }
  }
}
</style>
